import React, { useEffect, useState } from 'react';
import Modal from '../../../../../components/Modal';
import deleteMenu from '../../../../../assets/images/deleteMenu.png';
import PropTypes from 'prop-types';
import { useAssignmentContext } from '../../../context';
import CustomToast from '../../../../../components/Toast';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';

const baseUrl = appConfig.apiBaseUrl;
const DeleteMenuModal = ({ modalData, setModalData, fromMoreActions }) => {
  const token = useSelector(selectCurrentToken);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const { assignedData, assignmentId, setAssignedData, setAssignedDataStatus, assignedCount, setAssignedCount } =
    useAssignmentContext();

  const handleAssignmentsToDelete = () => {
    const notAssignedCount = assignedData.length > 0 ? assignedData.filter(x => x.assignedCount > 0).length : assignedCount;
    notAssignedCount > 0 ?
      setShowErrorMsg(true)
      : setShowErrorMsg(false);
  };

  const closeErrorHandler = () => {
    setAssignedDataStatus(new Date().getSeconds());
    setAssignedData([]);
    setModalData(false);
  };

  const deleteAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options =
          !fromMoreActions ? assignedData.map((item) => item.assignmentId) : [assignmentId];
        let url = baseUrl + '/Assignment/DeleteAssignments';
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const deleteResponse = await fetch(url, {
          headers,
          method: 'DELETE',
          body: JSON.stringify(options)
        });
        const result = deleteResponse.status;
        if (result === 200) {
          CustomToast('Assignment(s) Deleted Successfully', 'success');
          setAssignedDataStatus(new Date().getSeconds());
          setIsLoading(false);
          setShowErrorMsg(false);
          setModalData(false);
          setAssignedData([]);
          setAssignedCount(0);
        } else {
          setIsLoading(false);
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  };

  useEffect(() => {
    handleAssignmentsToDelete();
  }, [assignedData.length]);

  return (
    <>
      <Modal
        isOpen={modalData}
        onClose={() => setModalData(false)}
        contentWidth="700px"
        titleName={`${showErrorMsg ? 'Error' : 'Delete Assignment'}`}>
        {!showErrorMsg && (
          <div className="confirmation-wrapper m-3 pt-3">
            <div className="confirmation-content p-3">
              <div className="confirmation-icon pb-3">
                <img src={deleteMenu} className="img-fluid" />
              </div>
              <div>
                <p className="mb-0">
                  Are you sure that you want to delete the checked assignment(s)?
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center gap-2 delete-btn">
              <button className="btn btn-castleWhite" onClick={() => setModalData(false)}>
                No
              </button>
              <button className="btn btn-castleRed" onClick={deleteAsync} disabled={isLoading}>
                Yes
              </button>
            </div>
          </div>
        )}
        {showErrorMsg && (
          <div className="confirmation-wrapper">
            <div className="confirmation-content">
              <div>
                <p className="mb-0">
                  You have not selected any unassigned assignments to delete. Please unassign all
                  current AND Removed students from the selected assignment(s). Check &quot;Display
                  Removed Students&quot; on the Assignment Details page to view removed students.
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center gap-2 delete-btn">
              <button className="btn btn-castleRed" onClick={closeErrorHandler}>
                Ok
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

DeleteMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool
};

export default DeleteMenuModal;
